import React from 'react';
import { ThemeLoader } from '@sightworks/theme';
import RawContainerBlock from '../../raw/container/block';

const ContainerBlock = (props, ref) => (
	<RawContainerBlock {...props} ref={ref} />
);
const ThemedContainerBlock = ThemeLoader(ContainerBlock);
export default ThemedContainerBlock;
